module.exports = __webpack_public_path__ + "static/media/el_pojo.5670c505.jpg";